import { Asset } from '../types/interfaces';

export const AssetTemplate: Asset = {
  id: 0,
  name: '',
  description: '',
  type: {
    key: '',
    label: '',
    children: []
  },
  address: '',
  longitude: null,
  latitude: null,
  state: true,
  parameterValues: []
};
